<div class="switch-files">
  <a class="nav-link p-0" (click)="switchView(ViewType.Tile)" [class.active]="fileView === ViewType.Tile">
    <!-- TODO placeholder icon -->
    <span><i class="icon icon-grid-view" aria-hidden="true"></i></span>
  </a>
  <a class="nav-link p-0 ml-2" (click)="switchView(ViewType.Row)" [class.active]="fileView === ViewType.Row">
    <span><i class="icon icon-list-view" aria-hidden="true"></i></span>
  </a>

</div>
